var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"mb-4"},[_vm._v("Sorry, we can't find that page.")]),_c('p',{staticClass:"lead"},[_vm._v("It may have been moved, or the URL is incorrect.")])])}]

export { render, staticRenderFns }